const DEVELOPMENT_URL = "http://127.0.0.1:8000/api/";
const PRODUCTION_URL = "https://api.absdietplanet.com/api/";

export const MAIN_URL = PRODUCTION_URL;